// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__tBIrr","label":"CategoryService_label__1D62w","location":"CategoryService_location__JFyhc"};